import iconDonationTrain from "@/assets/overlays/donation-train/donation-train-overlay-icon.png";
import iconLeaderboard from "@/assets/overlays/leaderboard/icons/leaderboard-icon.svg";
import iconDashboard from "@/assets/tools/icons/dashboard-icon.png";

import type { Overlay } from "./types";

export const dashboards = {
  fundraising: {
    show: true,
    isNew: false,
    isUpdated: false,
    isFeatured: false,
    category: "dashboards",
    type: "dashboard",
    name: "Fundraising Overview",
    link: "/dashboards/fundraising",
    thumbnail: iconDashboard,
    imageClass: "chat-icon",
    shortDescription:
      "Utilize our fundraising dashboard to easily track your fundraising progress.",
    description: "Utilize our fundraising dashboard to easily track your fundraising progress.",
    features: [
      "<b>Update: Now displays claimed St. Jude rewards or votes on a poll</b>",
      "<b>Update: Set how many donors to display in your dashboard</b>",
      "Displays total amount raised with your goal",
      "Shows the percentage remaining to complete your goal",
      "Easily see when donors leave a comment, claim a reward or vote in a poll",
      "Tracks your progress toward completing your next milestone",
    ],
    overview: (
      <>
        Effortlessly track your fundraising progress during live streams with our intuitive
        dashboard. It displays claimed rewards, poll votes, donor comments, and milestones.
        Customize the number of donors shown, monitor total funds raised, and view the percentage
        remaining to reach your goal.
      </>
    ),
  },
  "leaderboard-exclusion": {
    show: true,
    isNew: true,
    isUpdated: false,
    isFeatured: false,
    category: "dashboards",
    type: "dashboard",
    name: "Leaderboard Exclusions",
    link: "/dashboards/leaderboard-exclusion",
    thumbnail: iconLeaderboard,
    imageClass: "chat-icon",
    shortDescription:
      "Hide donors from your Leaderboard overlay — signed in with your Tiltify account.",
    description:
      "Manage which donors appear on your Leaderboard overlay. Sign in with Tiltify, pick a campaign, and toggle donors on or off. Changes propagate to your overlay in real time.",
    features: [
      "Sign in with your Tiltify account — no admin key required",
      "Toggle any donor visible or hidden with a single click",
      "Manually add a name to hide donors that haven’t landed on the leaderboard yet",
      "Changes push to the Leaderboard overlay via WebSocket — no refresh required",
    ],
    overview: (
      <>
        Manage your Leaderboard overlay’s donor exclusion list from one place. Sign in with your
        Tiltify account, pick your campaign, and toggle donors on or off. Updates propagate to any
        active Leaderboard overlay for the same campaign in real time.
      </>
    ),
  },
  "donation-train": {
    show: true,
    isNew: true,
    isUpdated: false,
    isFeatured: false,
    category: "dashboards",
    type: "dashboard",
    name: "Donation Trains",
    link: "/dashboards/donation-train",
    thumbnail: iconDonationTrain,
    imageClass: "chat-icon",
    shortDescription:
      "Hide or unhide donation trains on your overlay — signed in with your Tiltify account.",
    description:
      "Review active, pending, and completed donation trains for your campaign and toggle any of them on or off the overlay. Changes propagate over WebSocket so the Donation Train overlay updates without a refresh.",
    features: [
      "Sign in with your Tiltify account — no admin key required",
      "See active, pending, and completed trains in a single view",
      "Hide or show any train with one click",
      "Inspect per-campaign high-rate donor and common-train stats",
      "Changes push to the Donation Train overlay via WebSocket — no refresh required",
    ],
    overview: (
      <>
        Manage your Donation Train overlay in real time. Sign in with your Tiltify account, pick
        your campaign, hide or unhide any train, and manage your rulesets.
      </>
    ),
  },
} satisfies Record<string, Overlay>;
